<template>
  <div>
    <!--搜索-->
    <div>
      <van-search
              v-model="queryParams.goodsName"
              show-action
              placeholder="请输入搜索关键词"
              @search="onSearch"
              style="padding:12px 12px"
              :clearable="false"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>

    <!-- 场馆分类 -->
    <div class="c-class">
      <van-tabs v-model="queryParams.classId" title-active-color="#2C68E4" :border="false" @change="tabChange">
        <van-tab title="全部" name="" v-if="classOptions.length > 0"/>
        <van-tab v-for="(item, index) in classOptions" :title="item.label" :name="item.value" :key="index"/>
      </van-tabs>
    </div>

    <!-- 列表 -->
    <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">
      <van-list
              v-model="data.bottomLoading"
              :finished="!data.hasMore"
              finished-text="没有更多了"
              @load="bottomRefresh()"
      >
        <div class="list-box" v-for="(item, index) in data.records" :key="index">
          <div class="box">
            <b>{{ item.code }}</b>
            <span>库存：{{ item.stockNum}}</span>
          </div>
          <div class="box">
            <b>{{ item.goodsName }}</b>
            <span>单位：{{ item.unit}}</span>
            <span>单价：{{ item.price}}元</span>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
  import {queryList, getClassOptions} from '@/api/stock/stock'
  import {handlePageData} from '@/utils/common'
  export default {
    name: 'StockList',
    components: {
    },
    data() {
      return {
        queryParams: {},
        classOptions: [],
        data: {
          records: [],
          current: 1,
          size: 10,
          total: 0,
          hasMore: true,
          loading: false,
          topLoading: false,
          bottomLoading: false
        }
      }
    },
    created() {
      getClassOptions().then(res => {
        if (res.code === 10000) {
          this.classOptions = res.result.filter(i => i.count > 0)
        }
      })
      this.refresh()
    },
    methods: {
      refresh() {
        this.reset()
        this.getList()
      },
      bottomRefresh() {
        if (this.data.current > 1 && this.data.hasMore)
          this.getList()
      },
      reset() {
        this.data.current = 1
        this.data.total = 0
        this.data.hasMore = true
      },
      getList() {
        if (this.data.loading) return
        this.data.loading = true
        this.queryParams.current = this.data.current
        this.queryParams.size = this.data.size

        queryList(this.queryParams).then(res => {
          if (res.code === 10000) {
            setTimeout(() => {
              handlePageData(this.data, res.result)
            }, 100)
          }
        }).finally(() => {
          setTimeout(() => {
            this.data.loading = false
            this.data.topLoading = false
            this.data.bottomLoading = false
          }, 100)
        })
      },
      tabChange() {
        this.$nextTick(() => {
          this.data.records = []
          this.refresh()
        })
      },
      onSearch() {
        this.refresh()
      }
    }
  }
</script>
<style scoped>
  .list-box {
    height: auto;
  }
  .list-box .box {
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
  }
</style>
